// tslint:disable
/**
 * Api för BT preliminärberäkning
 * Dokumentation av api för BT preliminärberäkning.
 *
 * The version of the OpenAPI document: 0.0.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BtPreliminarberakningBodyVO
 */
export interface BtPreliminarberakningBodyVO {
    /**
     * 
     * @type {HousingDataBodyVO}
     * @memberof BtPreliminarberakningBodyVO
     */
    bostadsuppgifter: HousingDataBodyVO;
    /**
     * 
     * @type {CustomerBodyVO}
     * @memberof BtPreliminarberakningBodyVO
     */
    kund1: CustomerBodyVO;
    /**
     * 
     * @type {CustomerBodyVO}
     * @memberof BtPreliminarberakningBodyVO
     */
    kund2?: CustomerBodyVO;
}
/**
 * 
 * @export
 * @interface CalculationEngineResponseVO
 */
export interface CalculationEngineResponseVO {
    /**
     * månad belopp 1
     * @type {number}
     * @memberof CalculationEngineResponseVO
     */
    manadsbelopp1?: number;
    /**
     * månad belopp 2
     * @type {number}
     * @memberof CalculationEngineResponseVO
     */
    manadsbelopp2?: number;
}
/**
 * 
 * @export
 * @interface CustomerBodyVO
 */
export interface CustomerBodyVO {
    /**
     * Kundens ålder vid datum för beräkning.
     * @type {number}
     * @memberof CustomerBodyVO
     */
    vSokandesAlder: number;
    /**
     * Årsbelopp SA
     * @type {number}
     * @memberof CustomerBodyVO
     */
    sabelopp?: number;
    /**
     * Tillgångar på bankkonton
     * @type {number}
     * @memberof CustomerBodyVO
     */
    konto?: number;
    /**
     * Tillgångar värdepapper
     * @type {number}
     * @memberof CustomerBodyVO
     */
    vardepapper?: number;
    /**
     * Övriga tillgångar som ska tas upp.
     * @type {number}
     * @memberof CustomerBodyVO
     */
    ovrigaTillgangar?: number;
    /**
     * Arbetsinkomst kronor per år.
     * @type {number}
     * @memberof CustomerBodyVO
     */
    vArbetsinkomst?: number;
    /**
     * Inkomst av kapital kronor per år.
     * @type {number}
     * @memberof CustomerBodyVO
     */
    vKapitalInkomst?: number;
    /**
     * Andra inkomster kronor per år
     * @type {number}
     * @memberof CustomerBodyVO
     */
    vAndraInkomster?: number;
    /**
     * Värde på annan fastighet än permanentbostaden. Taxeringsvärde.
     * @type {number}
     * @memberof CustomerBodyVO
     */
    vAnnanFastighet?: number;
    /**
     * Övriga skulder som inte härrör till permanentbostaden. Totalt skuldbelopp.
     * @type {number}
     * @memberof CustomerBodyVO
     */
    vSkulder?: number;
}
/**
 * 
 * @export
 * @interface FelmeddelandeRestVO
 */
export interface FelmeddelandeRestVO {
    /**
     * 
     * @type {string}
     * @memberof FelmeddelandeRestVO
     */
    kod?: string;
    /**
     * 
     * @type {string}
     * @memberof FelmeddelandeRestVO
     */
    parameternamn?: string;
    /**
     * 
     * @type {string}
     * @memberof FelmeddelandeRestVO
     */
    textnyckel?: string;
    /**
     * 
     * @type {string}
     * @memberof FelmeddelandeRestVO
     */
    meddelande?: string;
    /**
     * 
     * @type {string}
     * @memberof FelmeddelandeRestVO
     */
    detaljeradInformation?: string;
}
/**
 * 
 * @export
 * @interface HousingDataBodyVO
 */
export interface HousingDataBodyVO {
    /**
     * Om kund är gift/sammanboende.
     * @type {string}
     * @memberof HousingDataBodyVO
     */
    gift: HousingDataBodyVOGiftEnum;
    /**
     * LGH_1 = Hyrd lägenhet, LGH_2 = Bostadsrätt, LGH_3 = Servicelägenhet, LGH_8 = Gruppbostad, SMA_9 = Smahus, enfamiljhus, SMA_11 = Egen lantbruksenhet
     * @type {string}
     * @memberof HousingDataBodyVO
     */
    bostadstyp: HousingDataBodyVOBostadstypEnum;
    /**
     * Hyra som kronor per månad
     * @type {number}
     * @memberof HousingDataBodyVO
     */
    manadshyra?: number;
    /**
     * Bostadsyta i kvadratmeter
     * @type {number}
     * @memberof HousingDataBodyVO
     */
    bostadsyta?: number;
    /**
     * Lånekostnad i kronor per år
     * @type {number}
     * @memberof HousingDataBodyVO
     */
    skuldranta?: number;
    /**
     * Fastighetsavgift i kronor per år
     * @type {number}
     * @memberof HousingDataBodyVO
     */
    fastighetsskatt?: number;
    /**
     * Tomträttsavgäld i kronor per år
     * @type {number}
     * @memberof HousingDataBodyVO
     */
    tomtrattsavgald?: number;
    /**
     * Om hushållsel ingår i betald hyra/månadsavgift
     * @type {string}
     * @memberof HousingDataBodyVO
     */
    ingarHushallsel?: HousingDataBodyVOIngarHushallselEnum;
    /**
     * Antal egna barn under 20 år som bor i bostaden
     * @type {number}
     * @memberof HousingDataBodyVO
     */
    antalBarnUnder20?: number;
    /**
     * Antal egna barn över 20 år som bor i bostaden
     * @type {number}
     * @memberof HousingDataBodyVO
     */
    antalBarnOver20?: number;
    /**
     * Antal föräldrar till kund(er) som bor i bostaden.
     * @type {number}
     * @memberof HousingDataBodyVO
     */
    antalForaldrar?: number;
    /**
     * Antal syskon under 20 år till kund(er) som bor i bostaden.
     * @type {number}
     * @memberof HousingDataBodyVO
     */
    antalSyskonUnder20?: number;
    /**
     * Antal syskon över 20 år till kund(er) som bor i bostaden.
     * @type {number}
     * @memberof HousingDataBodyVO
     */
    antalSyskonOver20?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum HousingDataBodyVOGiftEnum {
    J = 'J',
    N = 'N'
}
/**
    * @export
    * @enum {string}
    */
export enum HousingDataBodyVOBostadstypEnum {
    LGH1 = 'LGH_1',
    LGH2 = 'LGH_2',
    LGH3 = 'LGH_3',
    LGH8 = 'LGH_8',
    SMA9 = 'SMA_9',
    SMA11 = 'SMA_11'
}
/**
    * @export
    * @enum {string}
    */
export enum HousingDataBodyVOIngarHushallselEnum {
    J = 'J',
    N = 'N'
}


/**
 * BtPreliminarberakningRestControllerApi - axios parameter creator
 * @export
 */
export const BtPreliminarberakningRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Hämtar beslut från beräkningsmotorn om kunden har rätt till bostadstillägg
         * @param {BtPreliminarberakningBodyVO} btPreliminarberakningBodyVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicV1GetBtResultPost(btPreliminarberakningBodyVO: BtPreliminarberakningBodyVO, options: any = {}): RequestArgs {
            // verify required parameter 'btPreliminarberakningBodyVO' is not null or undefined
            if (btPreliminarberakningBodyVO === null || btPreliminarberakningBodyVO === undefined) {
                throw new RequiredError('btPreliminarberakningBodyVO','Required parameter btPreliminarberakningBodyVO was null or undefined when calling publicV1GetBtResultPost.');
            }
            const localVarPath = `/public/v1/getBtResult`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof btPreliminarberakningBodyVO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(btPreliminarberakningBodyVO !== undefined ? btPreliminarberakningBodyVO : {}) : (btPreliminarberakningBodyVO || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BtPreliminarberakningRestControllerApi - functional programming interface
 * @export
 */
export const BtPreliminarberakningRestControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Hämtar beslut från beräkningsmotorn om kunden har rätt till bostadstillägg
         * @param {BtPreliminarberakningBodyVO} btPreliminarberakningBodyVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicV1GetBtResultPost(btPreliminarberakningBodyVO: BtPreliminarberakningBodyVO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculationEngineResponseVO> {
            const localVarAxiosArgs = BtPreliminarberakningRestControllerApiAxiosParamCreator(configuration).publicV1GetBtResultPost(btPreliminarberakningBodyVO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BtPreliminarberakningRestControllerApi - factory interface
 * @export
 */
export const BtPreliminarberakningRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Hämtar beslut från beräkningsmotorn om kunden har rätt till bostadstillägg
         * @param {BtPreliminarberakningBodyVO} btPreliminarberakningBodyVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicV1GetBtResultPost(btPreliminarberakningBodyVO: BtPreliminarberakningBodyVO, options?: any) {
            return BtPreliminarberakningRestControllerApiFp(configuration).publicV1GetBtResultPost(btPreliminarberakningBodyVO, options)(axios, basePath);
        },
    };
};

/**
 * BtPreliminarberakningRestControllerApi - object-oriented interface
 * @export
 * @class BtPreliminarberakningRestControllerApi
 * @extends {BaseAPI}
 */
export class BtPreliminarberakningRestControllerApi extends BaseAPI {
    /**
     * 
     * @summary Hämtar beslut från beräkningsmotorn om kunden har rätt till bostadstillägg
     * @param {BtPreliminarberakningBodyVO} btPreliminarberakningBodyVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BtPreliminarberakningRestControllerApi
     */
    public publicV1GetBtResultPost(btPreliminarberakningBodyVO: BtPreliminarberakningBodyVO, options?: any) {
        return BtPreliminarberakningRestControllerApiFp(this.configuration).publicV1GetBtResultPost(btPreliminarberakningBodyVO, options)(this.axios, this.basePath);
    }

}


